<template>
  <help-info-wrapper
    :info.sync="helpData"
    :service-name="serviceName"
    class="warp"
  >
    <template>
      <v-row no-gutters>
        <v-col
          v-for="(item, i) in filteredCategories"
          :key="i"
          class="py-6 px-md-6"
          cols="12"
          md="6"
        >
          <!-- <div class="rowinfo"> -->
          <cat-card :item="item">
            <template>
              <help-info
                :element-name="`${serviceName}-${componentName}-catBusinessShop-${item.route}`"
                :help-data="helpData"
                :label="`${item.name}`"
                :service-name="serviceName"
                :style="{
                  opacity: item.comingSoon ? 0.2 : 1,
                  'pointer-events': item.comingSoon ? 'none' : 'auto',
                  top: '46%',
                  boxShadow: 'none',
                  left: '4%',
                  position: 'relative',
                }"
                class="buttoninfo"
              />
            </template>
          </cat-card>
          <!-- </div> -->
        </v-col>
      </v-row>
    </template>
  </help-info-wrapper>
</template>

<script>
import CatCard from "./catCard";

export default {
  name: "catShare",

  components: { CatCard },

  data: () => ({
    serviceName: "Qrland",
    helpData: [],
    componentName: "cat-share",
  }),
  watch: {
    "$i18n.locale": {
      handler(newLocale) {
        this.$forceUpdate();
      },
      immediate: true,
    },
  },
  computed: {
    categories() {
      return [
        {
          name: this.$t("categories.electronic_business_card"),
          value: "",
          route: "qr.cardVisit",
          colors: ["#FF8008", "#FFC837", "#FF8008"],
          icon: "mdi-card-account-details-outline",
          topBade: {
            icon: "mdi-diamond-outline",
            text: this.$t("support_day60"),
          },
        },
        {
          name: this.$t("categories.electronic_business_card_pro"),
          value: "",
          route: "qr.cardVisitPro",
          colors: ["#F85D3E", "#BC9942", "#88B92D"],
          icon: "mdi-card-account-details-outline",
          pro:true,
          topBade: {
            icon: "mdi-diamond-outline",
            text: this.$t("support_day60"),
          },
        },
        // {
        //   name: this.$t("categories.social_media"),
        //   value: "",
        //   route: "qr.socialMedia",
        //   colors: ["#1E6F5C", "#29BB89", "#289672"],
        //   icon: "mdi-instagram",
        // },
        {
          name: this.$t("categories.photo_gallery"),
          value: "",
          route: "qr.photo",
          colors: ["#27374D", "#9DB2BF", "#526D82"],
          icon: "mdi-image-area",
        },
        {
          name: this.$t("categories.video_gallery"),
          value: "",
          route: "qr.video",
          colors: ["#EE91E9", "#8ED2C7", "#EE98E9"],
          icon: "mdi-image-area",
        },
        {
          name: this.$t("categories.link"),
          value: "",
          route: "qr.link",
          colors: ["#410445", "#EAE4D5", "#D76C82"],
          icon: "mdi-link-variant-plus",
        },
         {
          name: this.$t("categories.link_pro"),
          value: "",
          route: "qr.linkPro",
          colors: ["#453404", "#EAE4D5", "#C9D76C"],
          icon: "mdi-bullseye-arrow",
          pro:false
        },
        {
          name: this.$t("categories.audio_gallery"),
          value: "",
          route: "qr.voice",
          colors: ["#2B0F0F", "#2c3e50", "#593333"],
          icon: "mdi-folder-play",
          isTest: false,
        },
        {
          name: this.$t("categories.audio_gallery_pro"),
          value: "",
          route: "qr.voicePro",
          colors: ["#610C9F", "#DA0C81", "#940B92"],
          icon: "mdi-folder-play-outline",
          isTest: false,
        },
        {
          name: this.$t("categories.feedback"),
          value: "",
          route: "qr.feedback",
          colors: ["#EB5A3C", "#FFCDB2", "#E5989B"],
          icon: "mdi-comment-quote",
          isTest: false,
        },
        {
          name: this.$t("categories.consultation_form"),
          value: "",
          route: "qr.consultationQr",
          colors: ["#A87676", "#E1ACAC", "#CA8787"],
          icon: "mdi-list-box-outline",
          isTest: false,
        },
        {
          name: this.$t("categories.application"),
          value: "",
          route: "qr.application",
          colors: ["#000000", "#253900", "#08CB00"],
          icon: "mdi-application-braces-outline",
          // comingSoon: true,
        },
        {
          name: this.$t("categories.luck_wheel"),
          value: "",
          route: "qr.luckWheel",
          colors: ["#A72703", "#FCB53B", "#FFE797"],
          icon: "mdi-clover-outline",
          // comingSoon: true,
        },
        {
          name: this.$t("categories.pdf_gallery"),
          value: "",
          route: "qr.pdf",
          colors: ["#93291E", "#ED213A", "#93291E"],
          icon: "mdi-file-pdf-box",
          // comingSoon: true,
          isTest: false,
        },
        {
          name: this.$t("categories.schedule_table"),
          value: "",
          route: "qr.link",
          colors: ["#2c3e50", "#2980b9", "#2c3e50"],
          icon: "mdi-table-large-plus",
          comingSoon: true,
        },
         {
          name: this.$t("filters.qrType.text"),
          value: "",
          route: "qr.Qrtext",
          colors: ["#0b132b", "#1c3d5a", "#06b6d4"],
          icon: "mdi-card-text-outline",
        },
        {
          name:"کیوکارت",
          value: "",
          route: "qr.bankcards",
          colors: ["#1A237E", "#303F9F", "#E8EAF6"],
          icon: "mdi-credit-card-outline",
        },
       
      ];
    },
    filteredCategories() {
      const currentLocale = this.$i18n.locale;
      if (currentLocale === "fa") {
        return this.categories;
      }
      return this.categories.map((x) => ({
        ...x,
        comingSoon: x.route !== "qr.cardVisit",
      }));
    },
  },
};
</script>

<style scoped></style>
